<template>
    <div class="row">
        <template v-if="entradas.some(entrada => entrada.unidades > 0)">
            <div class="col-12 text-center">
                <h3>TUS ENTRADAS</h3>
            </div>
            <div class="col-12">
                <template v-for="(entrada, index) in entradas">
                    <p class="bg-secondary mb-2 p-2" :key="index" v-if="entrada.unidades > 0">
                        {{ ++index }}. {{ entrada.descripcion }} x{{ entrada.unidades }}
                    </p>
                </template>
            </div>
        </template>
        <template v-if="siguiente != null">
            <div class="col-12" v-if="siguiente">
                <div v-if="teatro.carrito_varios_eventos" class="d-flex flex-row justify-content-center">
                    <template v-if="!carrito || (carrito && carrito.items_count == 0)">
                        <Button @click.prevent="continuar" class="btn btn-primary mb-2 mb-md-0 me-md-2 mr-1" style="flex: 1;">CONTINUAR COMPRA</Button>
                        <Button id="add-cart" @click="checkCarrito()" class="btn btn-secondary ml-0 ml-md-1 mr-1 mr-md-0 mb-2 mb-md-0" :disabled="disableButtonCart"><i class="fa fa-cart-plus" aria-hidden="true"></i></Button>
                    </template>
                    <Button id="add-cart" v-else @click="checkCarrito()" class="btn btn-secondary ml-0 mr-1 mr-md-0" :disabled="disableButtonCart" style="flex: 1;">AÑADIR AL CARRITO</Button>
                </div>
                <Button v-else class="btn-block" @click.prevent="continuar">CONTINUAR COMPRA</Button>
            </div>
            <div class="col-12" v-else>
                <div class="alert alert-danger" role="alert">
                    El número máximo de entradas permitidas por pedido son 25
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        props: ['entradas', 'siguiente'],
        data() {
            return {
                disableButtonCart: false
            }
        },
        methods: {
            continuar() {
                this.$emit('continuar');
            },
            checkCarrito() {
                if (this.carrito) {
                    this.setItemsCarrito();
                } else {
                    this.crearCarrito();
                }
            },
            crearCarrito() {
                const params = {filters: {}};

                this.$store.dispatch(this.config.getVuexAlias('taquilla.carrito.crear'), params).then(res => {
                    this.setItemsCarrito();
                }).catch(error => {
                    this.$toast.error(error.response.data.message);
                })
            },
            setItemsCarrito() {
                this.disableButtonCart = true;

                const params = {
                    filters: {},
                    cart_id: this.carrito?.id,
                    asientos: this.getAsientosFormatted(),
                    plazas: []
                };

                this.$store.dispatch(this.config.getVuexAlias('taquilla.carrito.add-items'), params).then(res => {
                    this.$toast.success('Entradas añadidas al carrito correctamente.');
                    this.$store.dispatch('TAQUILLA_CARRITO_ACTIVO');
                    this.$router.push({path: "/admin/eventos"});
                }).catch(error => {
                    this.$toast.error(error.response.data.message);
                }).finally(() => {
                    this.disableButtonCart = false;
                });
            },
            getAsientosFormatted() {
                let asientos = [];

                this.entradas.map(entrada => {
                    if(entrada.unidades > 0) {
                        asientos.push({
                            precio: {
                                id: entrada.id
                            },
                            units: entrada.unidades,
                            event_id: this.evento_id,
                            event_session_id: this.sesion_id
                        })
                    }
                });

                return asientos;
            },
        },
        computed: {
            teatro() {
                return this.$store.getters.getTeatro;
            },
            evento_id() {
                return this.$route.params.evento_id;
            },
            sesion_id() {
                return this.$route.params.sesion_id;
            },
            carrito() {
                return this.$store.getters.getCarritoActivo;
            }
        },
        mounted() {
            window.addEventListener('update-plano', this.getCarritoActivo);
        }
    }
</script>